export default {
    getLang(defaultLang) {
        if (localStorage.getItem('lang')) {
            return localStorage.getItem('lang')
        } else {
            const localLang = navigator.language || navigator.userLanguage;

            switch (localLang.substring(0, 2)) {
                case 'zh':
                    localStorage.setItem('lang', 'zh_cn');
                    return 'zh_cn'
                default:
                    localStorage.setItem('lang', defaultLang);
                    return defaultLang
            }
        }
    }
}
